<template>
  <div>
    <div
      class="teach-styled styled-radio-container styled-radio-container--ou-donation row"
    >
      <div v-for="[amount, description] of amounts" :key="amount" class="amount-row">
        <input
          :id="`amount${amount}`"
          type="radio"
          class="amount"
          @click="selectedAmount = amount"
          :checked="selectedAmount == amount"
        />
        <FormLabel :for="`amount${amount}`">
          <span class="label-description" v-html="description"></span>
        </FormLabel>
      </div>

      <div class="amount_other__wrapper amount-row">
        <input
          id="amount_other_check"
          type="radio"
          class="amount"
          :checked="customSelected"
          @click="customSelected = true"
        />
        <input
          id="amount_other"
          type="number"
          min="1"
          name="amount_other"
          placeholder="Other"
          v-model="customAmount"
        />
      </div>
      <div></div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch, nextTick } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  setup() {
    const { setValue, form, settings, getValue } = usePaymentForm();

    const selectedAmount = ref();
    const ticketsQnt = ref();
    const customAmount = ref(form.value.amount);
    const customSelected = ref(false);
    const customQnt = ref(false);

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false;
        customAmount.value = null;
        setValue("amount", "" + selectedAmount);
      }
    });
    watch(customQnt, () => {
      customQnt.value = false;
      if (ticketsQnt) {
        setValue("amount", "" + 75 * ticketsQnt.value);
        setValue("custom.ticketsQnt", ticketsQnt.value);
      }
    });

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null;
        setValue("amount", null);
      }
    });

    watch(customAmount, async (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null;
        customSelected.value = true;
      }

      // make sure UI has vue has dealt with customSelected and then we'll set the customAmount
      await nextTick();

      if (!selectedAmount.value) {
        setValue("amount", customAmount || null);
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      ticketsQnt,
      clearOutSelectedValue,
      customSelected,
      customQnt,
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }
  input[type="radio"]:checked + label {
    background: #0075ff;
    color: white;
  }
  input[type="radio"]:checked + label .label-amount {
    background: #0367de;
    border-color: #1849ff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      font-weight: 500 !important;
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
input#tickets_qnt {
  background: #fff !important;
  box-shadow: none;
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: 500;
  display: inline-block;
  padding: 10px 5px 0px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
  @media (min-width: 720px) {
    padding: 5px 5px 0px;
  }
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
::v-deep .label-description {
  font-weight: normal;
  padding: 7px 5px 10px;
  align-items: center;
  justify-content: center;
  height: auto;
  display: flex;
  flex-flow: column;
  text-align: center;
  font-size: 12px;
  line-height: 1.4;
  span {
    color: #1aa8d3;
    font-weight: bold;
    font-size: 15px;
    padding-bottom: 3px;
    text-align: center;
  }
}

::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  .label-description span {
    color: white;
  }
}
.teach-styled.styled-radio-container--ou-donation.styled-radio-container label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}
.amount_other__wrapper.amount-row {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
  }
}
.amount-row.tickets-num {
  @media (max-width: 720px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    margin-top: 10px;
  }
}
</style>
